import React from 'react';

import { onGetLocalFromUtc } from '@/utils/Util';

const RestrictedInfo = ({ item, viewType = 'block-view' }) => {
	return (
		<div className={`restricted-box ${viewType}`}>
			<span className="status red-1 gray_dark_01">Restricted- 20 days</span>
			<div className={`date ${viewType !== 'inline-view' ? 'mt-1' : ''}`}>
				<ul className={`common-list-component ${viewType !== 'inline-view' ? 'mt-1' : ''}`}>
					<li>
						<span>Till {onGetLocalFromUtc(item?.reservationEndDate, 'DD MMM, YY')} </span>
					</li>
					<li>
						For:
						<span className="gray_dark_01"> {item?.reservedFor}</span>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default RestrictedInfo;
